import React, { useEffect, useState } from "react";
import {
  TableRow,
  TableCell,
  Collapse,
  Typography,
  makeStyles,
  Table,
  TableBody,
  TableHead,
  CircularProgress,
  Box,
  Grid,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import { presentFormatedData } from "../../../functionalComponents/dataFormatFunctions";
import { appUrl } from "../../../../../../../utils/config";
import ChatBox from "./commentBoxException";
import { fetchDSBatchDetails } from '../../../../../containers/actions/common/saslAction';


const useStyles = makeStyles((theme) => ({
  tableHead: {
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
  },
  statusClosed: {
    color: "white",
    backgroundColor: "red",
    fontWeight: "bold",
    borderRadius: "0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "2rem",
  },
  statusOpen: {
    color: "white",
    backgroundColor: "green",
    fontWeight: "bold",
    borderRadius: "0.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "4rem",
    height: "2rem",
  },
  orangeCheckbox: {
    color: "#F26336",
    "&.Mui-checked": {
      color: "#F26336",
    },
  },
  table: {
    // width: "100%",
    marginBottom: "20px",
  },
  tableCell: {
    borderBottom: "none", // Optional: Remove default bottom borders
    padding: "8px 16px",
    fontSize: "14px", // Adjust the font size if needed
    fontWeight: "500",
  },
  tableHeadCell: {
    borderBottom: "none",
    fontWeight: "bold",
    fontSize: "14px",
    padding: "8px 16px",
    textAlign: "left",
  },
  buttonGroup: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
  },
  addButton: {
    textTransform: 'none',
    borderRadius: '20px',
    width: '180px',
  },
  multipleLogo: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: '1.5rem',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  selectSty: {
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      paddingTop: '10px',
      paddingBottom: '10px',
      paddingRight:'32px'
    }
  }
}));



const ExceptionDetails = (props) => {
  const { batchDetails,showExceptionDetails,row} = props;
  const classes = useStyles();
  const [tableLoading, setTableLoading] = useState(true)
  const [exceptionTableError, setTableError] = useState(false)
  const [exceptionData, setExceptionData] = useState({});
 
 
  useEffect(() => {
    let url = null;
            
            const data = {
              batchNumber: batchDetails.vendorBatchNumber ? batchDetails.vendorBatchNumber: "",
    };
            axios
              .post(
                `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchQAExceptionDetails`,
                data
              )
              .then((res2) => {
                if (res2.data.status) {
                  setExceptionData(res2.data.data);
                  setTableLoading(false);
                } else {
                  setTableLoading(false);
                  setTableError(true);
                }
              })
              .catch((err) => {
                console.error(err);
                setTableLoading(false);
                setTableError(true);
              });
          

    return () => {
      window.URL.revokeObjectURL(url);
    };
  }, []);


  return (
    <Box margin={4}>
      <div style={{padding:'1rem', border:'1px solid rgba(0, 0, 0, 0.12)', backgroundColor:'#FAFAFA'}}>
        <Grid container>
          <Grid item>
          <Table className={classes.table}>
  <TableHead>
    <TableRow>
    {showExceptionDetails &&(
      <>
    <TableCell className={classes.tableHeadCell}>
        Sponsor name
      </TableCell>
      <TableCell className={classes.tableHeadCell}>
        CMO
      </TableCell>
      </>
    )}
      <TableCell className={classes.tableHeadCell}>
        Plant ID
      </TableCell>
      {showExceptionDetails &&(
      <TableCell className={classes.tableHeadCell}>
        PO number
      </TableCell>
      )}
      <TableCell className={classes.tableHeadCell}>
        Batch Number
      </TableCell>
      <TableCell className={classes.tableHeadCell}>
        Start Date
      </TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    <TableRow>
    {showExceptionDetails &&(
      <>
    <TableCell className={classes.tableCell}>
        {presentFormatedData(batchDetails?.sponsorOrgName)}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {presentFormatedData(batchDetails?.cmoMember)}
      </TableCell>
      </>
      )}
      <TableCell className={classes.tableCell}>
        {presentFormatedData(batchDetails.vendorPlant)}
      </TableCell>
      {showExceptionDetails &&(
      <TableCell className={classes.tableCell}>
        {presentFormatedData(row?.scheduleLineDetails?.scheduleAgreementNumber)}
      </TableCell>
      )}
      <TableCell className={classes.tableCell}>
        {presentFormatedData(batchDetails.vendorBatchNumber)}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {batchDetails?.batchStartDate ? moment(batchDetails.batchStartDate).format(
          "DD-MMM-YYYY"
        ):'NA'}
      </TableCell>
    </TableRow>
  </TableBody>
    </Table>
          </Grid>
        </Grid>
      
              <Table style={{ border: "1px solid #ddd", marginTop: "1rem" }}>
                <TableHead>
                      <TableRow>
                        
                    <TableCell align="left" style={{whiteSpace:'nowrap'}} className={classes.tableHead}>
                      Quality event ID
                    </TableCell>
                    <TableCell align="left" className={classes.tableHead}>
                      Quality event title
                    </TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}}  className={classes.tableHead}>
                      Created Date
                    </TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}} className={classes.tableHead}>
                      Assigned To (Role)
                    </TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}} className={classes.tableHead}>
                      Assigned To (User)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableLoading === true ? (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={12}>
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress color='primary' />
                      </div>
                    </TableCell>
                  </TableRow>)
                : exceptionTableError ? <TableRow style={{border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0',}}><TableCell
              colSpan={12}
              align='center'
              
            >
              Something went wrong. Please try again later.
            </TableCell>
            </TableRow> : exceptionData?.exceptionDetailsList ? exceptionData.exceptionDetailsList.map((row, index) => (
                    <TableRow style={{backgroundColor:'#fff'}}>
           
                    <TableCell align="left" style={{whiteSpace:'nowrap'}}>{row.collabrixExceptionID}</TableCell>
                    <TableCell align="left" >{row.exceptionDescription}</TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}}>
                      {moment(row.creationDate).format("DD-MMM-YYYY").toUpperCase()}
                    </TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}}>{row.roleAssigned}</TableCell>
                    <TableCell align="left" style={{whiteSpace:'nowrap'}}>{row.userAssignedName}</TableCell>
                  </TableRow>
                  )): <TableRow style={{backgroundColor:'#fff'}} >
                  <TableCell
                    colSpan={12}
                    align='center'
                  >
                    No Records Found
                  </TableCell>
                  </TableRow>}
                </TableBody>
        </Table>
        </div>
        {batchDetails?.vendorBatchNumber&& (
         <ChatBox
         batchDetails={batchDetails}
         //schrockenDeliveryScheduleBatchID={data.schrockenDeliveryScheduleBatchID}
         vendorMosymphonyID={batchDetails.vendorMosymphonyID}
        
        /> 
       )}
    </Box>
          
  );
};

export default ExceptionDetails;
